const isEscapeKey = (evt) => evt.key === 'Escape';

export {isEscapeKey};
